import React from 'react'
import { Radio } from 'antd'
import { Li } from 'meinian-package/src/baseComponent'
import Select from 'meinian-package/src/baseComponent/select'
import { STYLE_TYPE, STYLE_TYPE_TEXT } from 'common/config/enum'
import styles from './index.module.less'

export const StyleType = ({ params, setParams }) => {
  return <Li className="item">
    <span className="label">款式类型</span>
    <Radio.Group
      className="radio-group"
      onChange={e => setParams(pre => ({ ...pre, styleType: e.target.value }))}
      value={params.styleType || 0}
    >
      <Radio className="radio" value={STYLE_TYPE.ALL}>{STYLE_TYPE_TEXT[STYLE_TYPE.ALL]}</Radio>
      <Radio className="radio" value={STYLE_TYPE.BASED}>{STYLE_TYPE_TEXT[STYLE_TYPE.BASED]}</Radio>
      <Radio className="radio" value={STYLE_TYPE.FIGURE}>{STYLE_TYPE_TEXT[STYLE_TYPE.FIGURE]}</Radio>
      <Radio className="radio" value={STYLE_TYPE.THEME}>{STYLE_TYPE_TEXT[STYLE_TYPE.THEME]}</Radio>
    </Radio.Group>
  </Li>
}

export const StyleTypeSelect = ({ value = null, onChange }) => {
  const options = [
    { label: STYLE_TYPE_TEXT[STYLE_TYPE.BASED], value: STYLE_TYPE.BASED },
    { label: STYLE_TYPE_TEXT[STYLE_TYPE.FIGURE], value: STYLE_TYPE.FIGURE },
    { label: STYLE_TYPE_TEXT[STYLE_TYPE.THEME], value: STYLE_TYPE.THEME }
  ]
  return <div className={styles.styleTypeSelect}>
    <div className="styleTypeSelectLabel">款式类型：</div>
    <Select
      trigger="click"
      overlayStyle={{ padding: '0px' }}
      ulStyle={{ width: '128px', padding: '8px' }}
      placeholder="不限"
      data={options}
      value={value}
      onChange={val => onChange?.(val)}
      container={document.body}
      ulProps={{
        onClick: (e) => e.stopPropagation()
      }}
    />
  </div>
}
